import { render, staticRenderFns } from "./CustomerPackage.vue?vue&type=template&id=357ab95a&scoped=true"
import script from "./CustomerPackage.vue?vue&type=script&lang=js"
export * from "./CustomerPackage.vue?vue&type=script&lang=js"
import style0 from "./CustomerPackage.vue?vue&type=style&index=0&id=357ab95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ab95a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/CustomerPackage.vue
// module id = 2105
// module chunks = 31